import { categoryResource, CategoryResource } from '@witkac/kartamiejska-resources';
import { Category } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';

/**
 *
 *
 * @export
 * @class CategoriesModule
 * @extends {EntityModule<Category, CategoryResource>}
 */
export class CategoriesModule extends EntityModule<Category, CategoryResource> {
  constructor() {
    super(categoryResource);
    this.actions = {
      ...this.actions,
      /**
       * Dodaje szablon
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      add: async (context: any, data: any) => {
        data.category.id = await this.resource.add(data);
        context.commit('add', data.category);
        context.commit('incrementCount');
      },
      /**
       * Aktualizuje szablon
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      update: async (context: any, data: any) => {
        data.category.id = await this.resource.update(data.id, data);
        context.commit('update', data.category);
        context.commit('setEntity', data.category);
      }
    };
  }
}

export default new CategoriesModule();
